import { render, staticRenderFns } from "./TrackShippment.vue?vue&type=template&id=6ffaa84e&scoped=true"
import script from "./TrackShippment.vue?vue&type=script&lang=js"
export * from "./TrackShippment.vue?vue&type=script&lang=js"
import style0 from "./TrackShippment.vue?vue&type=style&index=0&id=6ffaa84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffaa84e",
  null
  
)

export default component.exports